import React from 'react'

export const Page10English = () => {
  return (
    <div className='page-container'>
         <h1>Yagashalai:</h1>
      <p>
        Yagashalai is said to be the 36 philosophical forms and Lord Shiva is said to be in the form of
Attamurtha and the form of the six Athuvas. Yagashalai is called Shanthiyatheethakalai.
      </p>
      <h1>Kumbabhishekam :</h1>
      <p>
       Fire is raised in the Kundams set up in the Yagashalai. They are found in the shapes of
quadrilaterals, triangles, Arthasastras, etc. Green tarpaulins are spread around the Kundams,
and the Samittas of Aal, Arasa, etc. are placed in the Kundams. The clean Agni that has been
churned is used to chant the appropriate mantras and meditate on the supreme deities in the
mind, and the fire is raised by using instruments called Shruku and Suruvam. Worship is done
through the three methods of mantra, action, and Bhavanai. The smoke rising in the Om
Kundam, the Veda, Sivakamam, Thirumurai, and the good intentions of the devotees, and the
auspiciousness of the Lord that is everywhere, will make the Kumbha shine. Then the Kumbha
will be endowed with complete divine power. Once the rituals performed in the Yagashala are
completed, the deities in the temple will be connected to the idols with a rope, gold and silver
wires. After that, the water in the Kumbha will be used to anoint the peaks and images. The
Vimana Kalasam will spread the power of the original idol throughout the world and bring
benefits to the world.

      </p>
      <h1>Greetings :</h1>
      <p style={{ fontWeight: "bold" }}>
        May the sky never rain, O king, and may the wealth of the lotus blossoms flow freely.
 <br />
        May the government be governed according to the principles of the Buddha, and may all
beings live without deficiency.
 <br />
        May the four hidden virtues be exalted, and may friendship and sacrifice be made
abundantly <br />
        May the world be enlightened and the Shaivite righteousness be spread throughout the
world.
      </p>
      <h1>Know your zodiac sign:
 :</h1>
      <p>
        Nowadays, horoscopes are told in newspapers and television. People love to read them to know
their horoscope. They look, but some of them only know the star they were born on. They do not
know their zodiac sign. This zodiac sign has been included in this book for their benefit.
      </p>
    </div>
  )
}
